/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @nx/enforce-module-boundaries */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  GoogleMap,
  Marker,
  OverlayView,
  Polyline,
  TrafficLayer,
  TransitLayer,
} from '@react-google-maps/api';
import { useGoogleMaps } from 'packages/novous_web/src/context/GoogleMapContext'
// import { useGeofences } from 'packages/novous_web/src/hooks/useGeofences';
// import { GeofenceLayer } from 'packages/novous_web/src/common/components/GeofenceLayer';
import { IconButton, useMediaQuery, useTheme, Typography } from '@mui/material';
import MapViewModal from 'packages/novous_web/src/common/components/MapViewModal';
import mapOption from 'packages/novous_web/src/assets/icons/Map Options.svg';
import plusIcon from 'packages/novous_web/src/assets/icons/Plus Stroke.svg';
import minusIcon from 'packages/novous_web/src/assets/icons/Minus Stroke.svg';
import expand from 'packages/novous_web/src/assets/icons/Expand.svg';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ClearIcon from '@mui/icons-material/Clear';
import PauseIcon from '@mui/icons-material/Pause';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import { useLocation } from 'react-router-dom';
import Drowsiness from '../../../../../assets/icons/Drowsiness.svg';
import Distracted from '../../../../../assets/icons/Distracted.svg';
import Phone_Calling from '../../../../../assets/icons/phone-calling.svg';
import Harsh_Braking from '../../../../../assets/icons/Hard Braking.svg';
import Forward_Collision from '../../../../../assets/icons/Forward Collision.svg';
import Camera_Block from '../../../../../assets/icons/Camera Block.svg';
import Lane_Departure from '../../../../../assets/icons/Location.svg';
import Vulnerable_Road_Alert from '../../../../../assets/icons/vulnerableRoadAlert.svg';
import Harsh_Acceleration from '../../../../../assets/icons/Harsh Acceleration.svg';
import Harsh_Turning from '../../../../../assets/icons/Harsh Turning.svg';
import Over_Speeding from '../../../../../assets/icons/Over Speeding.svg';
import Vehicle_Idling from '../../../../../assets/icons/VideoPlaybutton.svg';
import Continuous_Driving from '../../../../../assets/icons/ContinuousDrivingReport.svg';
import Night_Driving from '../../../../../assets/icons/NightDrivingEvent.svg';
import Smoking from '../../../../../assets/icons/Smoking.svg';
import Yawning from '../../../../../assets/icons/Yawning.svg';
import Seat_Belt from '../../../../../assets/icons/seatbelt.svg';
import vehicleIcon from 'packages/novous_web/src/assets/icons/MovingTruck.svg';
import Loader from 'packages/novous_web/src/common/components/Loader';
import { CircularProgress } from '@mui/material';
import { formatTimeTo24HourFormat } from 'packages/novous_web/src/utils/helper';
import { set } from 'react-datepicker/dist/date_utils';
import axisInstance from 'packages/novous_web/src/api/apiClient';
import { warningIcons } from '../../../Alarm/Vehicle-Alerts/helper/warningIcons';
import { getWarningIcon } from '../../../Alarm/Vehicle-Alerts/helper/warningIcons';
import SourceIcon from 'packages/novous_web/src/assets/icons/SourceIcon.svg';
import DestinationIcon from 'packages/novous_web/src/assets/icons/DestinationIcon.svg';
import alertMarker from 'packages/novous_web/src/assets/icons/alert.svg';
import AlertToast from 'packages/novous_web/src/common/components/Alert';

const defaultCenter = {
  lat: 28.6139,
  lng: 77.209,
};

interface TripDetailMapProps {
  startDate: string;
  endDate: string;
  stopsData: {
    index: number;
    latitude: number;
    longitude: number;
    gpsTime: string;
  }[];
  selectedTrip?: {
    latitude: number;
    longitude: number;
    startDate: string;
    endDate: string;
    type: string;
    startLat: number;
    startLong: number;
    endLat: number;
    endLong: number;
  };
  selectedvehicleData?: any;
  clearTrip?: () => void;
}

type AlertPoint = {
  latitude: number;
  longitude: number;
  alertName: string;
};

const RunningHistoryMap: React.FC<TripDetailMapProps> = ({
  stopsData,
  startDate,
  endDate,
  selectedTrip,
  selectedvehicleData,
  clearTrip,
}) => {
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const { isLoaded } = useGoogleMaps();
  // const { geofences } = useGeofences();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width:650px)');
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<google.maps.Map | null>(null);
  const [open, setOpen] = useState(false);
  const [mapType, setMapType] = useState<'roadmap' | 'satellite' | 'terrain' | 'hybrid'>('roadmap');
  const [showTraffic, setShowTraffic] = useState(true);
  const [showTransit, setShowTransit] = useState(false);
  const [showBicycling, setShowBicycling] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedPoint, setSelectedPoint] = useState<any>(null);
  const fetchID = useRef(0);
  const handleClear = () => {
    setSelectedMapData([]);
    setSelectedPoint(null);
    setSelectedMapPointsData([]);
    setIsSelected(false);
    setCurrentFetchType('default');
    setAnimationObj({
      isPlaying: false,
      animationIndex: 0,
      vehiclePosition: { lat: 0, lng: 0 },
    });
    clearTrip?.();
    if (animationRef.current) {
      clearInterval(animationRef.current);
    }
  };
  const [alertPointsData, setAlertPointsData] = useState<AlertPoint[]>([]);
  const {
    data: mapPointsData,
    loading: loadingMapPoints,
    fetchData: fetchmapPoints,
  } = useAxios<any>(API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP, 'POST');
  const {
    data: alertMapPoints,
    loading: loadingalertMapPoints,
    fetchData: fetchalertMapPoints,
  } = useAxios<any>(API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP_ALERTS, 'POST');
  const [nonAlertMapData, setNonAlertMapData] = useState<any[]>([]);
  const [selectedMapPointsData, setSelectedMapPointsData] = useState<any[]>([]);
  const [defaultMapData, setDefaultMapData] = useState<any[]>([]);
  const [alertDataCache, setAlertDataCache] = useState<any[]>([]);
  const [selectedMapData, setSelectedMapData] = useState<any[]>([]);
  const [currentFetchType, setCurrentFetchType] = useState<'default' | 'selected' | null>('default');
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const lastVehicle = location.state || {};
  const [vehicleData, setVehicleData] = useState<any>(lastVehicle);
  const [distantAlertPoints, setDistantAlertPoints] = useState<AlertPoint[]>([]);
  const { user } = useAuth();
  const [animationObj, setAnimationObj] = useState({
    isPlaying: false,
    animationIndex: 0,
    vehiclePosition: { lat: 0, lng: 0 },
  });
  const [heading, setHeading] = useState<number>(0);
  const [currentSpeed, setCurrentSpeed] = useState<{ speed: number; timer: string } | null>(null);
  const animationRef = useRef<number | null>(null);
  const animationPositionRef = useRef<{ segIdx: number; ptIdx: number; progress: number }>({ segIdx: 0, ptIdx: 0, progress: 0 });
  const [playbackSpeed, setPlaybackSpeed] = useState(1); // 1 = normal, 2 = fast, 0.5 = slow
  const [showSpeedOptions, setShowSpeedOptions] = useState(false);

  const warningIconMap = Object.fromEntries(
    warningIcons.map((item: any) => [item.warningName, item.iconName]),
  );

  // Handle bicycling layer toggle
  useEffect(() => {
    if (showBicycling) {
      // When bicycling is enabled, automatically switch mapType if needed
      setMapType('roadmap');
    }
  }, [showBicycling]);

  const alertIcons = [
    { alertName: 'Drowsiness', alertIcon: Drowsiness },
    { alertName: 'Distracted', alertIcon: Distracted },
    { alertName: 'Phone Calling', alertIcon: Phone_Calling },
    { alertName: 'Harsh Braking', alertIcon: Harsh_Braking },
    { alertName: 'Forward Collision', alertIcon: Forward_Collision },
    { alertName: 'Camera Block', alertIcon: Camera_Block },
    { alertName: 'Lane Departure', alertIcon: Lane_Departure },
    { alertName: 'Vulnerable Road User', alertIcon: Vulnerable_Road_Alert },
    { alertName: 'Harsh Acceleration', alertIcon: Harsh_Acceleration },
    { alertName: 'Harsh Turning', alertIcon: Harsh_Turning },
    { alertName: 'Over Speeding', alertIcon: Over_Speeding },
    { alertName: 'Vehicle Idling', alertIcon: Vehicle_Idling },
    { alertName: 'Continuous Driving', alertIcon: Continuous_Driving },
    { alertName: 'Night Driving', alertIcon: Night_Driving },
    { alertName: 'Smoking', alertIcon: Smoking },
    { alertName: 'Yawning', alertIcon: Yawning },
    { alertName: 'Seat Belt', alertIcon: Seat_Belt },
  ];

  useEffect(() => {
    if (!selectedvehicleData && !lastVehicle) return;
    setVehicleData(selectedvehicleData || lastVehicle);
  }, [selectedvehicleData, lastVehicle]);

  useEffect(() => {
    console.log('Vehicle Data:', selectedvehicleData);
  }, [selectedvehicleData]);

  useEffect(() => {
    if (selectedvehicleData || defaultMapData.length > 0) {
      const defaultLat = defaultMapData[0]?.latitude;
      const defaultLng = defaultMapData[0]?.longitude;

      setMapCenter({
        lat: defaultLat ?? selectedvehicleData?.lastLatitude,
        lng: defaultLng ?? selectedvehicleData?.lastLongitude,
      });
    }
  }, [selectedvehicleData, defaultMapData]);

  useEffect(() => {
    console.log('Default Map Data:', defaultMapData);
  }, [defaultMapData]);

  const fetchMapData = (startDate: any, endDate: any, lastEvaluatedKey = null) => {
    setLoading(true);
    fetchmapPoints({
      fleetId: user?.customer_id,
      vehicleId: selectedvehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
      startDate: startDate,
      endDate: endDate,
      lastEvaluatedKey: lastEvaluatedKey,
    });
  };

  const fetchAlertMapData = (startDate: any, endDate: any, alertEvaluatedKey = null) => {
    fetchalertMapPoints({
      fleetId: user?.customer_id,
      vehicleId: selectedvehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
      startDate: startDate,
      endDate: endDate,
      alertEvaluatedKey: alertEvaluatedKey,
    });
  };

  const fetchAllMapPoints = async (
    startDate: any,
    endDate: any,
    vehicleId: any,
    sessionID: any,
    fetchType: any,
  ) => {
    if (fetchType === 'default') {
      setLoading(true);
    } else if (fetchType === 'selected') {
      setIsSelected(true);
    }
    let allPoints: any[] = [];
    let lastEvaluatedKey = null;

    do {
      const response: any = await axisInstance({
        url: API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP,
        method: 'POST',
        data: {
          fleetId: user?.customer_id,
          vehicleId: vehicleId,
          startDate: startDate,
          endDate: endDate,
          lastEvaluatedKey: lastEvaluatedKey,
        },
        responseType: 'json',
      });

      console.log('Fetched Map Points:', response);

      const data = response?.data?.data?.mapRenderList || [];
      allPoints = allPoints.concat(data);

      lastEvaluatedKey = response?.data?.data?.lastEvaluatedKey;
    } while (lastEvaluatedKey && sessionID === fetchID.current);

    if (sessionID === fetchID.current) {
      if (fetchType === 'default') {
        setDefaultMapData(allPoints.flat(1));
        console.log(defaultMapData, 'defaultMapData');
        setLoading(false);
      } else if (fetchType === 'selected') {
        setSelectedMapData(allPoints.flat(1));
      }
    }
  };

  const fetchAllMapAlertPoints = async (
    startDate: any,
    endDate: any,
    vehicleId: any,
    sessionID: any,
    fetchType: any,
  ) => {
    let allAlertPoints: any[] = [];
    let alertEvaluatedKey = null;

    do {
      const response: any = await axisInstance({
        url: API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP_ALERTS,
        method: 'POST',
        data: {
          fleetId: user?.customer_id,
          vehicleId: vehicleId,
          startDate: startDate,
          endDate: endDate,
          alertEvaluatedKey: alertEvaluatedKey,
        },
        responseType: 'json',
      });

      console.log('Fetched Map Points:', response);

      const data = response?.data?.data?.mapRenderList || [];
      allAlertPoints = allAlertPoints.concat(data);

      alertEvaluatedKey = response?.data?.data?.alertEvaluatedKey;
    } while (alertEvaluatedKey && sessionID === fetchID.current);

    if (sessionID === fetchID.current) {
      setAlertPointsData(allAlertPoints.flat(1));
      console.log(alertPointsData, 'alertPointsData');
    }
  };

  useEffect(() => {
    const fetchDefaultData = () => {
      fetchID.current += 1;
      setCurrentFetchType('default');
      setIsSelected(false);
      setSelectedMapData([]);
      setSelectedPoint(null);
      setDefaultMapData([]);
      setNonAlertMapData([]);
      setAlertPointsData([]);
      setSelectedMapPointsData([]);
      fetchAllMapPoints(
        startDate,
        endDate,
        selectedvehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
        fetchID.current,
        'default',
      );
      fetchAllMapAlertPoints(
        startDate,
        endDate,
        vehicleData?.vehicleRegistrationNo,
        fetchID.current,
        currentFetchType,
      );
    };
    setAnimationObj({
      isPlaying: false,
      animationIndex: 0,
      vehiclePosition: { lat: 0, lng: 0 },
    });
    if (animationRef.current) {
      clearInterval(animationRef.current);
    }
    fetchDefaultData();
  }, [startDate, endDate, vehicleData?.vehicleRegistrationNo]);

  useEffect(() => {
    console.log('Selected Trip:', selectedTrip);
    const resetAnimationState = () => {
      stopAnimation();
      setAnimationObj({
        isPlaying: false,
        animationIndex: 0,
        vehiclePosition: { lat: 0, lng: 0 },
      });
    };

    if (selectedTrip) {
      if (selectedTrip?.type === 'RUNNING') {
        const fetchSelectedData = () => {
          setCurrentFetchType('selected');
          setSelectedMapData([]);
          setSelectedPoint(null);
          resetAnimationState();
          fetchAllMapPoints(
            selectedTrip.startDate,
            selectedTrip.endDate,
            selectedvehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
            fetchID.current,
            'selected',
          );
        };
        fetchSelectedData();
      } else if (selectedTrip?.type === 'IDLE' || selectedTrip?.type === 'STOP') {
        setCurrentFetchType('selected');
        setIsSelected(true);
        setSelectedMapData([]);
        setSelectedPoint(null);
        resetAnimationState();
        setSelectedPoint({
          lat: selectedTrip.startLat || selectedTrip.endLat,
          lng: selectedTrip.startLong || selectedTrip.endLong,
        });
      }
    } else {
      setCurrentFetchType('default');
      setSelectedMapData([]);
      resetAnimationState();
    }
  }, [selectedTrip]);

  useEffect(() => {
    if (!selectedPoint && (!selectedMapData || selectedMapData.length === 0) && defaultMapData.length > 0) {
      setMapCenter({
        lat: defaultMapData[0]?.latitude || defaultCenter.lat,
        lng: defaultMapData[0]?.longitude || defaultCenter.lng,
      });
      return;
    }
    if (selectedTrip?.type === 'RUNNING') {
      setMapCenter({ lat: selectedMapData[0]?.latitude, lng: selectedMapData[0]?.longitude });
    } else if (selectedTrip?.type === 'IDLE' || selectedTrip?.type === 'STOP') {
      setMapCenter({
        lat: selectedPoint?.lat || defaultCenter.lat,
        lng: selectedPoint?.lng || defaultCenter.lng,
      });
    }
  }, [selectedMapData, selectedPoint]);

  const getPointTimeValue = (point: any): number | null => {
    const candidates = [
      point?.gpsTime,
      point?.timeStamp,
      point?.timestamp,
      point?.eventTime,
      point?.createdAt,
    ];

    for (const value of candidates) {
      if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
      }

      if (typeof value === 'string' && value.trim()) {
        // Backend format: YYYY-MM-DD:HH:mm:ss
        const backendTsMatch = value.match(
          /^(\d{4})-(\d{2})-(\d{2}):(\d{2}):(\d{2}):(\d{2})$/,
        );
        if (backendTsMatch) {
          const [, year, month, day, hours, minutes, seconds] = backendTsMatch;
          return Date.UTC(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hours),
            Number(minutes),
            Number(seconds),
          );
        }

        const parsedDate = Date.parse(value);
        if (!Number.isNaN(parsedDate)) {
          return parsedDate;
        }

        const timeMatch = value.match(/^(\d{1,2}):(\d{2}):(\d{2})$/);
        if (timeMatch) {
          const hours = Number(timeMatch[1]);
          const minutes = Number(timeMatch[2]);
          const seconds = Number(timeMatch[3]);
          return hours * 3600 + minutes * 60 + seconds;
        }
      }
    }

    return null;
  };

  const getDistanceMeters = (
    from: google.maps.LatLngLiteral,
    to: google.maps.LatLngLiteral,
  ): number => {
    const R = 6371000;
    const toRadians = (deg: number) => (deg * Math.PI) / 180;

    const dLat = toRadians(to.lat - from.lat);
    const dLng = toRadians(to.lng - from.lng);
    const lat1 = toRadians(from.lat);
    const lat2 = toRadians(to.lat);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);

    return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const buildOrderedPolylinePath = (rawPoints: any[]): google.maps.LatLngLiteral[] => {
    const validPoints = rawPoints
      .map((point, index) => ({
        point,
        index,
        timeValue: getPointTimeValue(point),
      }))
      .filter(
        ({ point }) =>
          !point?.alert &&
          point?.type !== 'ALERT' &&
          typeof point?.latitude === 'number' &&
          Number.isFinite(point.latitude) &&
          typeof point?.longitude === 'number' &&
          Number.isFinite(point.longitude),
      );

    const hasAnyTimeValue = validPoints.some((item) => item.timeValue !== null);
    const orderedPoints = hasAnyTimeValue
      ? [...validPoints].sort((a, b) => {
        if (a.timeValue === null && b.timeValue === null) return a.index - b.index;
        if (a.timeValue === null) return 1;
        if (b.timeValue === null) return -1;
        if (a.timeValue === b.timeValue) return a.index - b.index;
        return a.timeValue - b.timeValue;
      })
      : validPoints;

    const path: google.maps.LatLngLiteral[] = [];
    for (const { point } of orderedPoints) {
      const lat = point.latitude;
      const lng = point.longitude;
      const candidate = { lat, lng };
      const prev = path[path.length - 1];
      const prevPrev = path[path.length - 2];

      // Drop immediate duplicate coordinates to avoid tiny noisy back-and-forth segments.
      if (prev && prev.lat === lat && prev.lng === lng) {
        continue;
      }

      // Ignore very tiny movement jitter.
      if (prev && getDistanceMeters(prev, candidate) < 2) {
        continue;
      }

      // Remove immediate A -> B -> A oscillation that causes visible forward/backward flicker.
      if (prevPrev && getDistanceMeters(prevPrev, candidate) < 3) {
        path.pop();
        continue;
      }

      path.push(candidate);
    }

    return path;
  };

  const defaultPolylinePath = useMemo(
    () => buildOrderedPolylinePath(defaultMapData),
    [defaultMapData],
  );

  const AlertPointsData = useMemo(
    () => alertPointsData.map((p) => ({ lat: p.latitude, lng: p.longitude, type: p.alertName })),
    [alertPointsData],
  );

  const calculateDistance = (
    point1: { lat: number; lng: number },
    point2: { lat: number; lng: number },
  ): number => {
    if (!point1 || !point2) return 0;

    // Use Google Maps geometry if available
    if (window.google?.maps?.geometry?.spherical) {
      return (
        google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(point1.lat, point1.lng),
          new google.maps.LatLng(point2.lat, point2.lng),
        ) / 1000
      ); // Convert to kilometers
    }

    // Fallback Haversine formula
    const R = 6371; // Earth's radius in km
    const dLat = deg2rad(point2.lat - point1.lat);
    const dLon = deg2rad(point2.lng - point1.lng);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(point1.lat)) * Math.cos(deg2rad(point2.lat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const deg2rad = (deg: number): number => deg * (Math.PI / 180);

  // Find the first alert from the source point
  const firstAlertFromSource = useMemo(() => {
    if (AlertPointsData.length === 0 || defaultPolylinePath.length === 0) {
      return null;
    }

    const sourcePoint = defaultPolylinePath[0];
    let closestAlert = AlertPointsData[0];
    let minDistance = calculateDistance(sourcePoint, closestAlert);

    for (let i = 1; i < AlertPointsData.length; i++) {
      const distance = calculateDistance(sourcePoint, AlertPointsData[i]);
      if (distance < minDistance) {
        minDistance = distance;
        closestAlert = AlertPointsData[i];
      }
    }

    return closestAlert;
  }, [AlertPointsData, defaultPolylinePath]);

  useEffect(() => {
    if (AlertPointsData.length > 1) {
      const distantPoints: AlertPoint[] = [];

      for (let i = 0; i < AlertPointsData.length - 1; i++) {
        const point1 = AlertPointsData[i];
        const point2 = AlertPointsData[i + 1];

        const distance = calculateDistance(point1, point2);

        console.log(`Distance between alert point ${i} and ${i + 1}: ${distance.toFixed(2)} km`);

        if (distance > 2) {
          if (!distantPoints.some((p) => p.latitude === point1.lat && p.longitude === point1.lng)) {
            distantPoints.push({
              latitude: point1.lat,
              longitude: point1.lng,
              alertName: point1.type || 'Unknown Alert',
            });
          }

          if (!distantPoints.some((p) => p.latitude === point2.lat && p.longitude === point2.lng)) {
            distantPoints.push({
              latitude: point2.lat,
              longitude: point2.lng,
              alertName: point2.type || 'Unknown Alert',
            });
          }

          console.log(`Points are more than 2km apart:`, point1, point2);
        }
      }

      setDistantAlertPoints(distantPoints);
      console.log('Distant alert points (>2km):', distantPoints);
    }
  }, [AlertPointsData]);

  // Must be declared before snap-to-road useEffects
  const selectedPolylinePath = useMemo(
    () => buildOrderedPolylinePath(selectedMapData ?? []),
    [selectedMapData],
  );

  // Render and animate on the raw GPS path so map output matches exported KML exactly.

  if (!isLoaded) return <div>Loading Map...</div>;

  const toggleFullscreen = () => {
    if (!containerRef.current) return;
    if (!document.fullscreenElement) {
      containerRef.current.requestFullscreen().then(() => setIsFullscreen(true));
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false));
    }
  };

  const speedOptions = [
    { label: '0.5x', value: 0.5 },
    { label: '1x', value: 1 },
    { label: '1.5x', value: 1.5 },
    { label: '2x', value: 2 },
  ];

  const startAnimation = (resumeFromSaved = false) => {
    if (animationRef.current) {
      clearInterval(animationRef.current);
      animationRef.current = null;
    }

    // Build segments to animate over based on current fetch type
    const segmentsToUse: google.maps.LatLngLiteral[][] =
      currentFetchType === 'selected'
        ? selectedPolylinePath.length > 0
          ? [selectedPolylinePath]
          : []
        : defaultPolylinePath.length > 0
          ? [defaultPolylinePath]
          : [];

    if (!segmentsToUse || segmentsToUse.length === 0) {
      return;
    }

    // Initialize or resume animation state
    let segIdx = resumeFromSaved ? animationPositionRef.current.segIdx : 0;
    let ptIdx = resumeFromSaved ? animationPositionRef.current.ptIdx : 0;
    let progress = resumeFromSaved ? animationPositionRef.current.progress : 0;

    segIdx = Math.max(0, Math.min(segIdx, segmentsToUse.length - 1));
    ptIdx = Math.max(0, Math.min(ptIdx, Math.max(0, segmentsToUse[segIdx].length - 1)));
    progress = Math.max(0, Math.min(progress, 0.999));

    // Set initial position
    const initialPos = resumeFromSaved && segmentsToUse[segIdx]?.[ptIdx]
      ? segmentsToUse[segIdx][ptIdx]
      : segmentsToUse[0][0];
    
    setAnimationObj((prev) => ({ isPlaying: true, animationIndex: ptIdx, vehiclePosition: initialPos }));

    const baseInterval = 50;
    const interval = baseInterval / playbackSpeed;

    // helper to safely set current speed if mapping exists
    const setSpeedFor = (globalIndexHint?: number) => {
      try {
        if (currentFetchType === 'selected') {
          const idx = ptIdx; // in selected single segment, ptIdx maps to selectedMapData
          const speedInfo = selectedMapData?.[idx];
          if (speedInfo) {
            const timeInfo = speedInfo.timeStamp || '';
            const modifiedTimeInfo = timeInfo.replace(/ /g, '');
            setCurrentSpeed({ speed: speedInfo.speed, timer: modifiedTimeInfo });
          }
        } else {
          // best-effort: try to find matching point in defaultMapData by lat/lng
          const seg = segmentsToUse[segIdx];
          const pt = seg?.[ptIdx];
          if (pt) {
            const found = defaultMapData?.find(
              (d) => Math.abs(d.latitude - pt.lat) < 0.000001 && Math.abs(d.longitude - pt.lng) < 0.000001,
            );
            if (found) {
              const timeInfo = found.timeStamp || '';
              const modifiedTimeInfo = timeInfo.replace(/ /g, '');
              setCurrentSpeed({ speed: found.speed, timer: modifiedTimeInfo });
            }
          }
        }
      } catch (e) {
        // ignore
      }
    };

    animationRef.current = window.setInterval(() => {
      const segment = segmentsToUse[segIdx];
      if (!segment || segment.length === 0) {
        stopAnimation(true);
        return;
      }

      // if we're at the last point of the segment, teleport to next segment if available
      if (ptIdx >= segment.length - 1) {
        if (segIdx + 1 >= segmentsToUse.length) {
          stopAnimation(true);
          return;
        } else {
          segIdx += 1;
          ptIdx = 0;
          progress = 0;
          const newPos = segmentsToUse[segIdx][ptIdx];
          setAnimationObj((prev) => ({ isPlaying: true, animationIndex: ptIdx, vehiclePosition: newPos }));
          // do not interpolate across segments (teleport)
          setSpeedFor();
          return;
        }
      }

      progress += 0.025 * playbackSpeed;
      if (progress >= 1) {
        progress = 0;
        ptIdx++;
      }

      // Save current position
      animationPositionRef.current = { segIdx, ptIdx, progress };

      if (ptIdx < segment.length - 1) {
        const startPoint = segment[ptIdx];
        const endPoint = segment[ptIdx + 1];
        const t = progress;
        const interpolatedPosition = {
          lat: startPoint.lat + (endPoint.lat - startPoint.lat) * t,
          lng: startPoint.lng + (endPoint.lng - startPoint.lng) * t,
        };

        const newHeading = getHeading(startPoint, interpolatedPosition);
        if (newHeading !== 0) setHeading(newHeading);

        setAnimationObj((prev) => ({
          isPlaying: true,
          animationIndex: ptIdx,
          vehiclePosition: interpolatedPosition,
        }));
        setSpeedFor();
      }
    }, interval);
  };

  const handleSpeedChange = (speed: number) => {
    setPlaybackSpeed(speed);
    setShowSpeedOptions(false);

    // If animation is currently playing, restart it with new speed from current position
    if (animationObj.isPlaying) {
      // Stop interval but don't reset position
      if (animationRef.current) {
        clearInterval(animationRef.current);
        animationRef.current = null;
      }
      // Restart with saved position
      setTimeout(() => {
        startAnimation(true);
      }, 50);
    }
  };

  const getHeading = (from: google.maps.LatLngLiteral, to: google.maps.LatLngLiteral): number => {
    if (window.google?.maps?.geometry?.spherical?.computeHeading) {
      return google.maps.geometry.spherical.computeHeading(
        new google.maps.LatLng(from.lat, from.lng),
        new google.maps.LatLng(to.lat, to.lng),
      );
    }

    // Fallback when the geometry library is not loaded.
    const toRadians = (deg: number) => (deg * Math.PI) / 180;
    const toDegrees = (rad: number) => (rad * 180) / Math.PI;

    const lat1 = toRadians(from.lat);
    const lat2 = toRadians(to.lat);
    const dLon = toRadians(to.lng - from.lng);

    const y = Math.sin(dLon) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

    return toDegrees(Math.atan2(y, x));
  };

  const stopAnimation = (isCompleted = false) => {
    console.log(animationRef.current, 'animationRef.current ');

    if (animationRef.current) {
      clearInterval(animationRef.current);
      animationRef.current = null;
    }

    // choose a sensible resting position when stopping
    const defaultPos = (() => {
      if (currentFetchType === 'selected') {
        return selectedPolylinePath?.[0] ?? defaultCenter;
      }
      if (defaultPolylinePath && defaultPolylinePath.length > 0) {
        return defaultPolylinePath[0];
      }
      return defaultCenter;
    })();

    // Reset position ref when stopping completely (not when just changing speed)
    if (isCompleted) {
      animationPositionRef.current = { segIdx: 0, ptIdx: 0, progress: 0 };
    }

    setAnimationObj((prev) => ({
      isPlaying: false,
      animationIndex: 0,
      vehiclePosition: isCompleted ? defaultPos : prev.vehiclePosition ?? defaultPos,
    }));
  };

  useEffect(() => {
    return () => {
      if (animationRef.current) {
        clearInterval(animationRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (animationObj.isPlaying && animationObj.vehiclePosition) {
      setMapCenter(animationObj.vehiclePosition);
    }
  }, [animationObj]);



  return (
    <>
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any}
      />
      <MapViewModal open={open} mapType={mapType} onClose={() => setOpen(false)} onSelect={setMapType} />
      <div
        ref={containerRef}
        style={{ position: 'relative', width: '100%', height: isSmallScreen ? '400px' : '100%' }}
      >
        {loading && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        )}
        {isSelected && (
          <div style={{ position: 'absolute', top: 10, right: 190, zIndex: 1000 }}>
            <IconButton
              onClick={handleClear}
              sx={{
                background: theme.palette.background.paper,
                padding: '8px',
                borderRadius: '8px',
                border: `1px solid ${theme.palette.border}`,
                '&:hover': { background: theme.palette.background.paper },
              }}
            >
              <ClearIcon sx={{ fontSize: 32 }} />
            </IconButton>
          </div>
        )}
        <div style={{ position: 'absolute', top: 10, right: 130, zIndex: 1000 }}>
          <IconButton
            onClick={() => {
              animationObj.isPlaying ? stopAnimation() : startAnimation();
            }}
            sx={{
              background: theme.palette.background.paper,
              padding: '8px',
              borderRadius: '8px',
              border: `1px solid ${theme.palette.border}`,
              '&:hover': { background: theme.palette.background.paper },
            }}
          >
            {animationObj.isPlaying ? (
              <PauseIcon sx={{ fontSize: 32 }} />
            ) : (
              <PlayArrowIcon sx={{ fontSize: 32 }} />
            )}
          </IconButton>
        </div>
        <div
          style={{
            position: 'absolute',
            top: 10,
            right: 190,
            zIndex: 1000,
            display: animationObj.isPlaying ? 'flex' : 'none',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <IconButton
            onClick={() => {
              const newSpeed = Math.max(0, playbackSpeed - 1);
              handleSpeedChange(newSpeed);
            }}
            sx={{
              width: '48px',
              height: '48px',
              padding: '8px',
              borderRadius: '8px',
              background: theme.palette.linkActive,
              border: `1px solid ${theme.palette.border}`,
              boxShadow: '4px 4px 16px 0px #1E1E1E1A',
              '&:hover': {
                background: theme.palette.border,
              },
            }}
            disabled={playbackSpeed <= 0.25}
          >
            <img src={minusIcon} alt="Decrease Speed" />
          </IconButton>
          <IconButton
            sx={{
              background: theme.palette.background.paper,
              padding: '8px',
              borderRadius: '8px',
              border: `1px solid ${theme.palette.border}`,
              width: '48px',
              height: '48px',
              '&:hover': { background: theme.palette.background.paper },
            }}
          >
            <span
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {playbackSpeed}x
            </span>
          </IconButton>
          <IconButton
            onClick={() => {
              const newSpeed = Math.min(8, playbackSpeed + 1);
              handleSpeedChange(newSpeed);
            }}
            sx={{
              width: '48px',
              height: '48px',
              padding: '8px',
              borderRadius: '8px',
              background: theme.palette.linkActive,
              border: `1px solid ${theme.palette.border}`,
              boxShadow: '4px 4px 16px 0px #1E1E1E1A',
              '&:hover': {
                background: theme.palette.border,
              },
            }}
            disabled={playbackSpeed >= 8}
          >
            <img src={plusIcon} alt="Increase Speed" />
          </IconButton>
        </div>
        <div style={{ position: 'absolute', top: 10, right: 70, zIndex: 1000 }}>
          <IconButton
            onClick={() => setOpen(true)}
            sx={{
              background: theme.palette.background.paper,
              padding: '8px',
              borderRadius: '8px',
              border: `1px solid ${theme.palette.border}`,
              '&:hover': { background: theme.palette.background.paper },
            }}
          >
            <img src={mapOption} width={32} height={32} />
          </IconButton>
        </div>
        {/* Traffic Layer Controls */}
        <div
          style={{
            position: 'absolute',
            bottom: 80,
            left: 10,
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <IconButton
            onClick={() => setShowTraffic(!showTraffic)}
            sx={{
              background: showTraffic ? theme.palette.info.main : theme.palette.background.paper,
              padding: '8px',
              borderRadius: '8px',
              border: `1px solid ${theme.palette.border}`,
              color: showTraffic ? 'white' : 'inherit',
              '&:hover': { background: showTraffic ? theme.palette.info.main : theme.palette.background.paper },
            }}
            title="Toggle Traffic Layer"
          >
            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>🚦</span>
          </IconButton>
          <IconButton
            onClick={() => setShowTransit(!showTransit)}
            sx={{
              background: showTransit ? theme.palette.info.main : theme.palette.background.paper,
              padding: '8px',
              borderRadius: '8px',
              border: `1px solid ${theme.palette.border}`,
              color: showTransit ? 'white' : 'inherit',
              '&:hover': { background: showTransit ? theme.palette.info.main : theme.palette.background.paper },
            }}
            title="Toggle Transit Layer"
          >
            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>🚌</span>
          </IconButton>
          <IconButton
            onClick={() => setShowBicycling(!showBicycling)}
            sx={{
              background: showBicycling ? theme.palette.info.main : theme.palette.background.paper,
              padding: '8px',
              borderRadius: '8px',
              border: `1px solid ${theme.palette.border}`,
              color: showBicycling ? 'white' : 'inherit',
              '&:hover': { background: showBicycling ? theme.palette.info.main : theme.palette.background.paper },
            }}
            title="Toggle Bicycling Layer"
          >
            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>🚴</span>
          </IconButton>
        </div>
        <div style={{ position: 'absolute', top: 10, right: 70, zIndex: 1000 }}>
          <IconButton
            onClick={() => setOpen(true)}
            sx={{
              background: theme.palette.background.paper,
              padding: '8px',
              borderRadius: '8px',
              border: `1px solid ${theme.palette.border}`,
              '&:hover': { background: theme.palette.background.paper },
            }}
          >
            <img src={mapOption} width={32} height={32} />
          </IconButton>
        </div>
        <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
          <IconButton
            onClick={toggleFullscreen}
            sx={{
              width: '48px',
              height: '48px',
              padding: '8px',
              borderRadius: '8px',
              background: theme.palette.linkActive,
              border: `1px solid ${theme.palette.border}`,
              boxShadow: '4px 4px 16px 0px #1E1E1E1A',
              '&:hover': {
                background: theme.palette.border,
              },
            }}
          >
            <img src={expand} alt="Expand" />
          </IconButton>
        </div>

        {/* Alert and Video Info Card */}
        {AlertPointsData.length > 0 && (
          <div
            style={{
              position: 'absolute',
              top: 8,
              left: 10,
              zIndex: 1000,
              width: '120px',
              gap: '8px',
              opacity: 1,
              borderRadius: '8px',
              borderWidth: '1px',
              paddingTop: '8px',
              paddingRight: '16px',
              paddingBottom: '8px',
              paddingLeft: '16px',
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.border}`,
              boxShadow: '4px 4px 16px 0px #1E1E1E1A',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/* Alerts */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  background: theme.palette.error.main,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={
                    firstAlertFromSource
                      ? getWarningIcon(firstAlertFromSource.type) || alertMarker
                      : alertMarker
                  }
                  alt="alert"
                  style={{
                    width: '20px',
                    height: '20px',
                    filter: 'brightness(0) saturate(100%) invert(100%)',
                  }}
                />
              </div>
              <Typography
                sx={{
                  fontFamily: 'Inter Tight',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '21px',
                  letterSpacing: '0%',
                  color: theme.palette.text.primary,
                }}
              >
                Alerts
              </Typography>
            </div>
          </div>
        )}

        {/* Zoom controls */}
        <div
          style={{
            position: 'absolute',
            bottom: 16,
            right: 16,
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <IconButton
            onClick={() => {
              if (mapRef.current) {
                const currentZoom = mapRef.current.getZoom() ?? 12;
                mapRef.current.setZoom(currentZoom + 1);
              }
            }}
            sx={{
              width: '48px',
              height: '48px',
              padding: '8px',
              borderRadius: '8px',
              background: theme.palette.linkActive,
              border: `1px solid ${theme.palette.border}`,
              boxShadow: '4px 4px 16px 0px #1E1E1E1A',
              '&:hover': {
                background: theme.palette.border,
              },
            }}
          >
            <img src={plusIcon} alt="Zoom In" />
          </IconButton>
          <IconButton
            onClick={() => {
              if (mapRef.current) {
                const currentZoom = mapRef.current.getZoom() ?? 12;
                mapRef.current.setZoom(currentZoom - 1);
              }
            }}
            sx={{
              width: '48px',
              height: '48px',
              padding: '8px',
              borderRadius: '8px',
              background: theme.palette.linkActive,
              border: `1px solid ${theme.palette.border}`,
              boxShadow: '4px 4px 16px 0px #1E1E1E1A',
              '&:hover': {
                background: theme.palette.border,
              },
            }}
          >
            <img src={minusIcon} alt="Zoom Out" />
          </IconButton>
        </div>

        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={mapCenter}
          zoom={animationObj.isPlaying ? 14 : 12}
          onLoad={(map) => {
            mapRef.current = map;
          }}
          options={{
            zoomControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            rotateControl: false,
            scaleControl: false,
            tilt: 0,
            heading: 0,
            disableDefaultUI: true,
            mapTypeId: showBicycling ? 'bicycle' : mapType,
            keyboardShortcuts: false,
            gestureHandling: 'greedy',
          }}
        >
          {/* Traffic Layer */}
          {showTraffic && <TrafficLayer />}

          {/* Transit Layer */}
          {showTransit && <TransitLayer />}

          {/* Geofences */}
          {/* <GeofenceLayer geofences={geofences} /> */}

          {/* Default trip polyline */}
          {currentFetchType === 'default' &&
            defaultPolylinePath.length > 1 && (
              <Polyline
                path={defaultPolylinePath}
                options={{
                  strokeColor: 'blue',
                  strokeOpacity: 0.8,
                  strokeWeight: 4,
                  geodesic: true,
                  zIndex: 1,
                }}
              />
            )}

          {/* Selected trip polyline */}
          {currentFetchType === 'selected' &&
            selectedPolylinePath.length > 1 && (
              <Polyline
                path={selectedPolylinePath}
                options={{
                  strokeColor: 'blue',
                  strokeOpacity: 0.8,
                  strokeWeight: 4,
                  geodesic: true,
                  zIndex: 2,
                }}
              />
            )}

          {defaultPolylinePath.length > 0 && (
            <>
              <Marker
                key="Source"
                position={{
                  lat: defaultPolylinePath[0].lat,
                  lng: defaultPolylinePath[0].lng,
                }}
                icon={{
                  url: SourceIcon,
                  scaledSize: new google.maps.Size(40, 40),
                  anchor: new google.maps.Point(20, 40),
                }}
              />

              <Marker
                key="Destination"
                position={{
                  lat: defaultPolylinePath[defaultPolylinePath.length - 1].lat,
                  lng: defaultPolylinePath[defaultPolylinePath.length - 1].lng,
                }}
                icon={{
                  url: DestinationIcon,
                  scaledSize: new google.maps.Size(40, 40),
                  anchor: new google.maps.Point(20, 40),
                }}
              />
            </>
          )}

          {AlertPointsData.map((alert, index) => {
            const matchedIcon = getWarningIcon(alert.type) || null;
            return (
              <OverlayView
                key={`alert-${index}`}
                position={{ lat: alert.lat, lng: alert.lng }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              >
                <div
                  style={{
                    position: 'absolute',
                    width: '24px',
                    height: '24px',
                    borderRadius: '27px',
                    background: theme.palette.error.main,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transform: 'translate(-50%, -50%)',
                  }}
                >
                  <img
                    src={matchedIcon || 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png'}
                    alt="alert"
                    style={{
                      width: '16px',
                      height: '16px',
                      filter: 'brightness(0) saturate(100%) invert(100%)',
                    }}
                  />
                </div>
              </OverlayView>
            );
          })}

          {selectedTrip && selectedPolylinePath.length > 0 && (
            <>
              <Marker
                position={{
                  lat: selectedPolylinePath[0]?.lat ?? defaultCenter.lat,
                  lng: selectedPolylinePath[0]?.lng ?? defaultCenter.lng,
                }}
                icon={{
                  url: SourceIcon,
                  scaledSize: new google.maps.Size(40, 40),
                  anchor: new google.maps.Point(20, 40),
                }}
              />
              <Marker
                position={{
                  lat: selectedPolylinePath[selectedPolylinePath.length - 1]?.lat ?? defaultCenter.lat,
                  lng: selectedPolylinePath[selectedPolylinePath.length - 1]?.lng ?? defaultCenter.lng,
                }}
                icon={{
                  url: DestinationIcon,
                  scaledSize: new google.maps.Size(40, 40),
                  anchor: new google.maps.Point(20, 40),
                }}
              />
            </>
          )}

          {selectedTrip && selectedPoint && (
            <>
              <Marker
                position={{
                  lat: selectedPoint?.lat ?? defaultCenter.lat,
                  lng: selectedPoint?.lng ?? defaultCenter.lng,
                }}
                label={selectedTrip?.type === 'IDLE' ? 'IDLE' : 'STOP'}
                icon={
                  selectedTrip?.type === 'IDLE'
                    ? {
                      url: 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
                    }
                    : {
                      url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                    }
                }
              />
            </>
          )}

          {animationObj.vehiclePosition && (
            <OverlayView
              position={animationObj.vehiclePosition}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div
                style={{
                  transform: `rotate(${heading}deg)`,
                  transition: 'transform 0.3s ease',
                  width: '50px',
                  height: '50px',
                  top: '-25px',
                  left: '-25px',
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img src={vehicleIcon} alt="truck" style={{ width: '100%', height: '100%' }} />
              </div>
            </OverlayView>
          )}

          {/* Custom Info Box */}
          {animationObj.vehiclePosition && (
            <OverlayView
              position={animationObj.vehiclePosition}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div
                style={{
                  background: 'white',
                  padding: '8px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                  marginBottom: '40px',
                  minWidth: '100px', // 👈 Set min width or fixed width
                  textAlign: 'center',
                }}
              >
                <div>
                  <strong>Speed:</strong> {currentSpeed?.speed ?? 0} km/h
                </div>
                <div>
                  <strong>Time:</strong> {formatTimeTo24HourFormat(currentSpeed?.timer ?? '')}
                </div>
              </div>
            </OverlayView>
          )}
        </GoogleMap>
      </div>
    </>
  );
};

export default RunningHistoryMap;
